var _title, _desc, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMenuFeed = function SvgMenuFeed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "4C7E84E5-386B-44C9-8F18-A3BB6565553D")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design-System",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Design-system",
    transform: "translate(-31.000000, -1240.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu-feed",
    transform: "translate(31.000000, 1240.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#CEE9F3",
    cx: 18,
    cy: 18,
    r: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1812822,7.83558883 C18.8323938,7.49291705 18.377125,7.32638746 17.9248389,7.33412833 C17.4770405,7.3417924 17.0321657,7.52028583 16.6963545,7.86779203 L10.0007888,14.7965377 C9.68546975,15.122838 9.50922008,15.5588578 9.50922008,16.0126177 C9.50922008,16.4102341 9.6419687,16.7767948 9.86524496,17.0706931 C9.97151851,17.2105808 10.098412,17.3338939 10.2413615,17.4362094 L10.2412997,23.9392069 C10.2412997,24.4224632 10.4371751,24.8599632 10.7538628,25.1766509 C11.0705505,25.4933386 11.5080505,25.689214 11.9912997,25.689214 L16.2768183,25.689214 L16.5278733,20.0264179 L19.6316985,20.2764179 L19.6316985,25.689214 L23.9182719,25.689214 C24.401521,25.689214 24.839021,25.4933386 25.1557087,25.1766509 C25.4668835,24.8654761 25.6614156,24.4376586 25.6680942,23.9644093 L26.0792878,17.023433 C26.2869808,16.7305272 26.3941931,16.3874128 26.4000952,16.0425645 C26.4077593,15.5947661 26.244594,15.1440439 25.9087828,14.7965377 L19.1812822,7.83558883 Z",
    id: "nav-home-act",
    stroke: "#84C8E1",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    strokeLinejoin: "round"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMenuFeed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu-feed.c4dc671b.svg";
export { ForwardRef as ReactComponent };